// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3smOD","title":"ClientInsurance_title__ddv_O","itemText":"ClientInsurance_itemText__353ke"};